import { useState } from "react";
import { Link } from "react-router-dom";
import { Snowflake, Mail } from "lucide-react";
import api, { errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 bg-sky-500 border-2 border-slate-900 shadow-[4px_4px_0px_0px_#0f172a] flex items-center justify-center">
            <Snowflake className="w-7 h-7 text-white" />
          </div>
          <div className="font-display text-2xl uppercase leading-none text-slate-900">
            On <span className="bg-sky-500 text-white px-1.5 -skew-x-3 inline-block">Ice</span>
          </div>
        </div>

        <div className="card-brutal shadow-[8px_8px_0px_0px_#0f172a] p-6 md:p-8">
          <h1 className="font-display text-2xl uppercase text-slate-900 mb-1">Reset password</h1>
          <p className="text-sm text-slate-600 mb-6">We'll email you a reset link.</p>

          {done ? (
            <div className="border-2 border-emerald-500 bg-emerald-50 text-emerald-800 p-3 font-mono-tight text-xs font-bold" data-testid="forgot-password-confirmation">
              If that email is registered, a reset link has been sent. Check your inbox.
            </div>
          ) : (
            <form onSubmit={submit} data-testid="forgot-password-form">
              {error && (
                <div className="border-2 border-rose-500 bg-rose-50 text-rose-700 p-3 font-mono-tight text-xs font-bold mb-4" data-testid="forgot-password-error">
                  {error}
                </div>
              )}
              <label className="label-brutal" htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                data-testid="forgot-password-email-input"
                type="email"
                required
                className="input-brutal mb-6"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit" className="btn-primary w-full" disabled={busy} data-testid="forgot-password-submit-button">
                <Mail className="w-4 h-4" /> {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
          )}

          <div className="mt-4 text-center">
            <Link to="/login" className="font-mono-tight text-xs uppercase tracking-widest font-bold text-sky-600 hover:text-sky-800 underline" data-testid="back-to-login-link">
              Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
